// src/design-system/components/PurpleButton.jsx
import React from 'react';

/**
 * PurpleButton — Roxo neon premium #7E22CE.
 * Uso: plano recomendado, upgrade, ações premium.
 */
export default function PurpleButton({
  children,
  className = '',
  size = 'md',
  fullWidth = false,
  loading = false,
  disabled = false,
  as: Tag = 'button',
  ...props
}) {
  const cls = [
    'ds-btn-purple',
    size === 'lg' && 'ds-btn-purple--lg',
    size === 'sm' && 'ds-btn-purple--sm',
    fullWidth && 'ds-btn-purple--full',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={cls} disabled={disabled || loading} {...props}>
      {loading && (
        <svg className="mp-anim-spin" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2v4m0 12v4m10-10h-4M6 12H2m15.07-7.07l-2.83 2.83M9.76 14.24l-2.83 2.83m12.14 0l-2.83-2.83M9.76 9.76L6.93 6.93" />
        </svg>
      )}
      {children}
    </Tag>
  );
}
